import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { getPostalInfo } from '../../utils/api/salePointApi';

class PostalCodeFields extends React.Component {
  state = {
    postalCode: '',
    postalCity: '',
    errors: {},
  };

  componentDidMount() {
    const providedFields = {};

    if (this.props.postalCode) {
      providedFields.postalCode = this.props.postalCode;
    }

    if (this.props.postalCity) {
      providedFields.postalCity = this.props.postalCity;
    }

    if (Object.keys(providedFields).length > 0) {
      this.setState(providedFields);
    }
  }

  /**
   * Notifies the parent component
   * that the city has changed
   * */
  notifyChangedPostalCity = (postalCode, postalCity) => {
    this.props.onChange({
      postalCode,
      postalCity,
    });
  };

  findPostalCode = (postalCode) => {
    if (!postalCode || postalCode.trim().length !== 4) {
      // Reset any postalCode values
      this.notifyChangedPostalCity(postalCode, null);
      return;
    }

    getPostalInfo(postalCode)
      .then((data) => {
        if (data.error) {
          this.setState({
            postalCity: '',
            errors: { postalCode: data.msg },
          });
          this.notifyChangedPostalCity(postalCode, null);
          return;
        }

        this.setState({
          postalCity: data.data,
          errors: {},
        });
        this.notifyChangedPostalCity(postalCode, data.data);
      });
  };

  render() {
    const { postalCity, errors } = this.state;

    return <Fragment>
      <label htmlFor="postalCode">Postnummer</label>
      <input
        type="text"
        id="postalCode"
        maxLength="4"
        onChange={(evt) => this.findPostalCode(evt.target.value)}
        className="input is-light"
        placeholder="7049"
        minLength="4"
        name="postalCode"
        autoComplete="postal-code"
      />
      {errors.postalCode && <div className="form-error">{errors.postalCode}</div>}

      <input
        type="text"
        id="postalCity"
        name="postalCity"
        className="input is-light"
        placeholder="TRONDHEIM"
        readOnly
        value={postalCity}/>
      {errors.postalCity && <div className="form-error">{errors.postalCity}</div>}
    </Fragment>;
  }
}

PostalCodeFields.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default PostalCodeFields;
